import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画作品", to: "/works" },
  { label: "漫圈社区", to: "/circles" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="grid h-9 w-9 md:h-10 md:w-10 place-items-center rounded-full bg-primary-500 text-background-50 text-lg font-bold shadow-sm group-hover:scale-105 transition-transform">
            漫
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
            178漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                pathname === link.to
                  ? "text-background-50 bg-primary-500"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-primary-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/circles"
            className="inline-flex items-center gap-1.5 rounded-full border border-primary-300 text-primary-700 px-4 py-2 text-sm font-medium hover:bg-primary-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-user-heart-line" />
            加入漫圈
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始追漫
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center rounded-lg bg-background-100 text-foreground-800 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-lg px-4 py-3 text-sm font-medium ${
                pathname === link.to
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-2 flex gap-2">
            <Link
              to="/circles"
              className="flex-1 text-center rounded-full border border-primary-300 text-primary-700 px-4 py-2.5 text-sm font-medium whitespace-nowrap"
            >
              加入漫圈
            </Link>
            <Link
              to="/works"
              className="flex-1 text-center rounded-full bg-primary-500 text-background-50 px-4 py-2.5 text-sm font-medium whitespace-nowrap"
            >
              开始追漫
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}